<template>
  <section class="is-variable section mentor-container">
    <div class="columns">
      <div class="column is-6">
        <div class="container is-fluid">
          <div class="mentor-box-top">
            <div class="mentorIconContainer">
              <img class="icon mentorIcon" :src="mentor.profile_image" alt />
            </div>
            <p class="mentorText is-size-3">{{ mentor.full_name}}</p>
          </div>
          <div class="contact-div level column is-four-fifths" v-if="mentor">
            <p class="level-item mentorItem">{{ mentor.bio }}</p>
          </div>
          <div v-if="skypeLink" class="column has-text-left">
            <a :href="skypeLink">
              <span class="icon is-large">
                <font-awesome-icon class="skype" :icon="['fab','skype']" />
              </span>Call your mentor on skype
            </a>
          </div>
          <div>
            <!-- <iframe
          :src="mentorVideoUrl"
          width="1000"
          height="500"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
            ></iframe>-->
            <div style="padding:56.25% 0 0 0;position:relative;" v-if="mentorVideoUrl !=''">
              <iframe
                :src="mentorVideoUrl"
                style="position:absolute;top:0;left:0;width:100%;height:100%;"
                frameborder="0"
                allow="autoplay; fullscreen"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-6">
        <h2 class="subtitle">Book a slot with your mentor</h2>
        <table class="table is-fullwidth is-bordered is-striped">
          <thead>
            <tr>
              <th class="has-text-centered">Time</th>
              <th class="has-text-centered">Book</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(slot, i) of availability" :key="i">
              <td>{{slot.start}}</td>
              <td>
                <button
                  @click="handleBookingClick(slot)"
                  class="button is-link is-fullwidth is-outlined"
                  :disabled="(bookingSuccess && slot.status == 'Book') || slot.status == 'Booked'"
                >{{slot.status}}</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- <img class="background-image" src="../assets/img/icons/genex-dashboard.svg" alt> -->
  </section>
</template>
        <script src="https://player.vimeo.com/api/player.js"></script>

<script>
import EMenu from "../../components/layout/EMentor.vue";
import BaseHelper from "../../helpers/BaseHelper";
import { ChatClient } from "../../clients/ChatClient";
import { CalendarClient } from "../../clients/CalendarClient";
import { mapState } from "vuex";

export default {
  name: "Mentor",
  props: ["mentorId"],
  components: {
    EMenu
  },
  data() {
    return {
      availability: Object,
      bookingSuccess: false
    };
  },
  mixins: [BaseHelper],
  methods: {
    handleBookingClick(slot) {
      if (slot.status == "Unbook") {
        slot.status = "Book";
        this.unbookMentorSlot(slot.id);
      } else if (slot.status == "Book") {
        this.bookingSuccess = true;
        this.bookMentorSlot(slot.id);
      }
    },
    getMentor() {
      ChatClient.getMentor()
        .then(response => {
          this.getMentorAvailability(response.data.data.mentor.id);
        })
        .catch(error => {
          console.log(error.response);
        });
    },
    getMentorAvailability() {
      CalendarClient.getUserAvailability(this.mentor.id)
        .then(response => {
          this.availability = response.data.availabilities;
          this.processAvailability();
        })
        .catch(error => {
          console.log(error.response);
        });
    },
    bookMentorSlot(availability_id) {
      CalendarClient.bookMentorSlot(
        this.$store.state.auth.user.id,
        availability_id
      )
        .then(response => {
          this.getMentorAvailability();
        })
        .catch(error => {
          console.log(error);
          this.getMentorAvailability();
        });
    },
    unbookMentorSlot(availability_id) {
      CalendarClient.unbookMentorSlot(
        this.$store.state.auth.user.id,
        availability_id
      )
        .then(response => {
          this.bookingSuccess = false;

          this.getMentorAvailability();
        })
        .catch(error => {
          console.log(error);
        });
    },
    processDate(date) {
      var options = {
        weekday: "long",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
      };
      var today = new Date(date).toUTCString();
      var process = new Date(today);
      return process.toLocaleString("default", options);
    },
    processAvailability() {
      for (var slot of this.availability) {
        slot.start = this.processDate(slot.start);
        if (
          slot.bookedBy.some(e => e.user_id == this.$store.state.auth.user.id)
        ) {
          slot.status = "Unbook";
          this.bookingSuccess = true;
        } else if (slot.bookedBy.length > 0) {
          slot.status = "Booked";
        } else {
          slot.status = "Book";
        }
      }
      let sortingList = this.availability;
      this.availability = sortingList.sort(function(a, b) {
        return new Date(a.start) - new Date(b.start);
      });
    }
  },

  computed: {
    ...mapState({
      mentor(state) {
        return state.auth.user.mentor.filter(
          mentor => mentor.id == this.mentorId
        )[0];
      }
    }),
    skypeLink() {
      if (!this.mentor.id) {
        return "";
      }

      let meta = this.mentor.meta.filter(meta => meta.meta_key == "skype_link");

      if (meta[0]) {
        return "skype:" + meta[0].meta_value + "?call";
      } else {
        return "";
      }
    },
    mentorVideoUrl() {
      if (!this.mentor.id) {
        return "";
      }

      let meta = this.mentor.meta.filter(
        meta => meta.meta_key == "mentor_video"
      );

      if (meta[0]) {
        return meta[0].meta_value;
      } else {
        return "";
      }
    }
  },
  mounted() {
    this.getMentorAvailability(this.mentorId);
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";
.mentorItem {
  margin-top: auto;
  text-align: left;
}
.contact-link {
  :hover {
    fill: green;
  }

  color: $pantoneBlue;
}
.skypeBox {
  margin-bottom: 1rem;
}
.skype {
  height: 3.5rem !important;
  width: auto !important;
}
.button.is-link {
  min-width: 8rem;
  font-weight: bold !important;
  border-color: $pantoneBlue !important;
  color: $pantoneBlue !important;
  background-color: transparent !important;
  &.is-active {
    background-color: $pantoneBlue !important;
    color: white !important;
  }
  &:hover {
    background-color: $pantoneBlue !important;
    color: white !important;
  }
}
.mentorText {
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  bottom: 0%;
  left: 0;
  width: 100%;
  text-transform: uppercase;
  color: white;
}
.mentor-container {
  margin-left: auto;
  margin-right: auto;
  padding-left: 4rem;
  position: relative;
}
.background-image {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 380px;
  height: auto;
  z-index: -10;
  opacity: 0.3;
}
.mentorIconContainer {
  position: absolute;
  width: 100%;
  top: -4rem;
  @media screen and (max-width: 768px) {
    .mentorIcon {
      height: 6rem;
      width: 6rem;
      margin-left: auto;
      margin-right: auto;
    }
    position: relative;
    top: 0;
  }
}
.mentorIcon {
  height: 7rem;
  width: 7rem;
  border-radius: 50%;
  margin-left: auto;
  margin-right: auto;
}
div:nth-of-type(1) {
  .mentor-box-top {
    background-color: $pantoneBlue;
  }
}
div:nth-of-type(2) {
  .mentor-box-top {
    background-color: $cyan;
  }
}
div:nth-of-type(3) {
  .mentor-box-top {
    background-color: $lightBlue;
  }
}
.mentor-box-top {
  height: 100px;
  position: relative;
  margin-top: 3.4rem;
  margin-bottom: 1rem;
}
.mentor-chat-box {
  height: 500px;
  width: 360px;
  border: 1px solid #f1f1f1;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 49;
  background-color: #fff;
  box-shadow: 0px 1px 13px #988f8f;
  border-top-left-radius: 10px;
  padding: 15px 15px 30px;
  .mentor-chat-box-msg-board {
    height: 85%;
    width: 100%;
    background-color: #f7f7f7;
    padding: 15px;
    overflow-y: scroll;
    p {
      display: block;
      text-align: left;
      margin-bottom: 10px;
      &.not-same-entity {
        text-align: right;
      }
      span {
        display: block;
      }
    }
  }
  .mentor-chat-box-msg-input {
    height: calc(100% - 86%);
    position: relative;
    input {
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
}
.mentor-chat-btn {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>